export const gelatoItems = [
  {
    name: "Four Berries",
    description: "A vibrant blend of strawberry, raspberry, blueberry, and blackberry",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/d49624af-6f10-42e7-8123-8b23e4e3ae13_compressed_IMG_20260722_155314.webp",
  },
  {
    name: "Mango Basil",
    description: "Sweet Alphonso mango with a refreshing hint of Thai basil",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/de78a5a1-5581-4f0f-bfde-401354b03622_compressed_IMG_20260722_155257.webp",
  },
  {
    name: "Apple Pie",
    description: "Cinnamon-spiced apple chunks folded into creamy vanilla gelato",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/eda0d22d-cce4-4393-91d7-fcdd87fa952e_compressed_IMG_20260722_164059.webp",
  },
  {
    name: "Chocolate Orange",
    description: "Rich dark chocolate infused with zesty Sicilian orange peel",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/984e9bfe-cd07-457b-a48b-08df9384d90e_compressed_choco.webp",
  },
  {
    name: "Black Sesame",
    description: "Nutty roasted black sesame, smooth and deeply aromatic",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/96a71984-f360-49f2-96c0-6e20cd91dd0f_compressed_IMG_20260722_162148.webp",
  },
  {
    name: "Jasmine",
    description: "Delicate floral jasmine tea blended into silky milk gelato",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/7ca2eb9e-ac37-4fe7-81ed-0c00c64097b7_compressed_jasine.webp",
  },
  {
    name: "Chrysanthemum Stracciatella",
    description: "Floral chrysanthemum base with fine dark chocolate shards",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/f1b657c8-f0f5-4992-8c7f-b86d9d218a15_compressed_krisantemum.webp",
  },
  {
    name: "Genmaicha",
    description: "Toasted brown rice green tea, earthy and comforting",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/b70df416-6dba-4db3-a528-d86e4e67d279_compressed_Screenshot-2026-07-30-220637.webp",
  },
  {
    name: "Osmanthus Oolong",
    description: "Fragrant osmanthus flowers with premium oolong tea leaves",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/2de76fe4-0673-49c1-826c-95fca53c16f9_compressed_osmanthus.webp",
  },
  {
    name: "Strawberry Cheesecake",
    description: "Creamy cheesecake gelato swirled with tangy strawberry compote",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/d616ea04-3023-466f-b95f-0d57468bd6a5_compressed_stoberi-ciskek.webp",
  },
  {
    name: "Da Hong Pao",
    description: "Legendary Wuyi rock tea, bold roasted depth with honey finish",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/d994933a-a3d1-4c26-b7ae-41b9babc8dd3_compressed_Screenshot-2026-07-30-220212.webp",
  },
  {
    name: "Lemon Almond Nibs",
    description: "Zesty lemon curd with crunchy caramelized almond nibs",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/37c7b2b5-bd7e-4905-a402-37c8ed923a31_compressed_Screenshot-2026-07-30-220223.webp",
  },
  {
    name: "Pistachio",
    description: "100% Sicilian Bronte pistachios, intensely nutty and smooth",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/3c03f838-799c-4fd1-927d-d5e3dfc1f7c2_compressed_Screenshot-2026-07-30-220235.webp",
  },
];

export const pastryItems = [
  {
    name: "Plain Croissant",
    description: "Classic French butter croissant, flaky and golden",
    image: "https://readdy.ai/api/search-image?query=Classic%20golden%20brown%20French%20butter%20croissant%20with%20visible%20flaky%20laminated%20layers%20on%20a%20dark%20rustic%20wooden%20board%20warm%20soft%20side%20lighting%20buttery%20sheen%20elegant%20minimalist%20presentation%20dark%20moody%20background%20premium%20bakery%20photography&width=500&height=500&seq=pastry-plain-croissant&orientation=squarish",
  },
  {
    name: "Sausage Roll",
    description: "Flaky puff pastry wrapped around seasoned pork sausage, golden and savory",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/4b330b39-68c6-47b1-917c-03952528fe8a_compressed_Screenshot-2026-07-23-001901.webp",
  },
  {
    name: "Almond Croissant",
    description: "Twice-baked croissant filled with frangipane and sliced almonds",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/b2898638-acec-439b-a54d-be8e70b5d467_compressed_Screenshot-2026-07-23-000917.webp",
  },
  {
    name: "Ham & Cheese Pain Suisse",
    description: "Smoked ham and Gruyère in sweet brioche pastry",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/2f013f4f-d4f0-4a4b-9708-0715bee08a7f_compressed_Screenshot-2026-07-23-001547.webp",
  },
  {
    name: "Pineapple Coconut Pain Suisse",
    description: "Tropical pineapple jam with toasted coconut cream",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/f0c7a75f-e2f8-47d1-a2eb-6429ba14d4cc_compressed_Screenshot-2026-07-22-204532.webp",
  },
  {
    name: "Strawberry Danish",
    description: "Buttery Danish pastry crowned with fresh strawberries",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/3a27c573-aec9-4d9f-aa0a-205f98486dc9_compressed_Screenshot-2026-07-22-204545.webp",
  },
  {
    name: "Blueberry Danish",
    description: "Cream cheese and wild blueberry compote on flaky Danish",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/66cb7cc4-7f15-4854-9436-2df9b9b22c3b_compressed_Screenshot-2026-07-23-135542.webp",
  },
  {
    name: "Lemon Passion Monkey Bread",
    description: "Pull-apart bread glazed with lemon and passion fruit",
    image: "https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/425fe534-5b8b-4999-9eb6-37f22d5e8def_compressed_Screenshot-2026-07-23-140050.webp",
  },
  {
    name: "Matcha Mochi Toast",
    description: "Crispy toasted shokupan with chewy matcha mochi topping",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/65d5cb8f-3099-46cd-938f-70013fdd3c19_compressed_Screenshot-2026-07-30-215618.webp",
  },
  {
    name: "Black Sesame Mochi Toast",
    description: "Golden toast layered with nutty black sesame mochi",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/7fbc303e-c578-42f1-add4-0a6854174a08_compressed_Screenshot-2026-07-30-215611.webp",
  },
];

export const beverageItems = [
  {
    name: "Black",
    description: "Bold double espresso with velvety crema",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/2dd3e3d7-a3e5-47fa-8274-65ce43a5a442_compressed_Screenshot-2026-07-31-152003.webp",
  },
  {
    name: "White",
    description: "Smooth espresso balanced with steamed milk",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/034e2e4f-07a4-4d4b-a72e-5ee499f695b0_compressed_Screenshot-2026-07-31-152333.webp",
  },
  {
    name: "Piccolo",
    description: "Mini latte with a strong espresso punch",
    image: "https://readdy.ai/api/search-image?query=Mini%20piccolo%20latte%20in%20a%20small%20clear%20glass%20with%20visible%20layered%20espresso%20and%20steamed%20milk%20gradient%20delicate%20latte%20art%20heart%20on%20top%20on%20a%20dark%20slate%20surface%20warm%20side%20lighting%20elegant%20specialty%20coffee%20presentation%20dark%20background%20premium%20beverage%20photography&width=500&height=500&seq=beverage-piccolo&orientation=squarish",
  },
  {
    name: "Dirty Latte",
    description: "Cold milk topped with a hot espresso shot, layered and bold",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/2e07f05e-551b-43d9-bd7f-0ca27db7b231_compressed_Screenshot-2026-07-31-152447.webp",
  },
  {
    name: "Matcha Latte",
    description: "Premium ceremonial matcha whisked with velvety steamed milk",
    image: "https://public.readdy.ai/ai/img_res/edited_a8d2824f00277efd2b9ffe7969ff2bdf_8f6cf2a9.jpg",
  },
  {
    name: "Matcha Coconut",
    description: "Creamy matcha blended with smooth coconut milk",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/8438b2dd-76f1-4c0c-91b0-7615f14da00f_compressed_Screenshot-2026-07-31-163518.webp",
  },
  {
    name: "Pistachio Matcha",
    description: "Nutty pistachio cream layered with ceremonial matcha",
    image: "https://public.readdy.ai/ai/img_res/edited_54c1311b2725973e75f352f60104216d_8e35fd83.jpg",
  },
  {
    name: "Matcha Strawberry",
    description: "Layered matcha over fresh strawberry milk",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/d04a0cde-e7d3-4b0d-8d98-a5a447c2e41d_compressed_Screenshot-2026-07-22-013404.webp",
  },
  {
    name: "Chocolate",
    description: "Rich Belgian chocolate melted into steamed milk",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/9ee3b4aa-691e-4cd8-a278-c1eb278256c3_compressed_Screenshot-2026-07-31-160439.webp",
  },
  {
    name: "Lemon Passion Ice Tea",
    description: "Chilled citrus tea with tangy passion fruit",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/bce3af38-536c-4d55-bdd2-545a46acf74f_compressed_Screenshot-2026-07-31-152826.webp",
  },
  {
    name: "Free Flow House Drink",
    description: "Rotating seasonal house-made refresher",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/c0f65829-8e7c-45da-a9c4-9d9a1ed69871_compressed_Screenshot-2026-07-31-152932.webp",
  },
  {
    name: "Morning Boost",
    description: "Fresh pressed: Orange, Carrot, Apple",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/ecf7ba79-289e-4f34-aeb7-40655e74f5fa_compressed_Screenshot-2026-07-31-154445.webp",
  },
  {
    name: "Pistachio Dirty Latte",
    description: "Pistachio cream meets bold espresso over chilled milk",
    image: "https://public.readdy.ai/ai/img_res/edited_a15e0382a283dd1d93e1d7ae9e99377a_771fdbf7.jpg",
  },
  {
    name: "Dear Sunshine",
    description: "Fresh pressed: Tomato, Orange, Lemon",
    image: "https://public.readdy.ai/ai/img_res/edited_88bb51319c7537794dadd4ea196f0a75_07908b29.jpg",
  },
  {
    name: "Applebeat",
    description: "Fresh pressed: Apple, Beetroot, Lemon",
    image: "https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/a7459f2d-9df7-4002-9153-c8318d9247e6_compressed_Screenshot-2026-07-31-153300.webp",
  },
];